import {
	ADMINCREATECURRENCYMAPPING_SUCCESS,
	ADMINCREATECURRENCYMAPPING_FAILED,
	RESET_ADMINCREATECURRENCYMAPPING,
	LOADING_ADMINCREATECURRENCYMAPPING,
	NETWORK_ERROR_ADMINCREATECURRENCYMAPPING
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetAdminCreateCurrencyMapping = () => {
	return { type: RESET_ADMINCREATECURRENCYMAPPING };
};

const adminCreateCurrencyMapping =
	(userData, authTokenIs) => async (dispatch) => {
		dispatch({ type: LOADING_ADMINCREATECURRENCYMAPPING });
		await adminServices
			.post("createCurrencyMapping", userData, { headers: { AuthToken: authTokenIs } })
			.then((res) => {
				switch (res.data.status) {
					case "success":
						dispatch(adminCreateCurrencyMappingsuccess(res.data));
						break;
					default:
						dispatch(adminCreateCurrencyMappingFailed(res.data));
						break;
				}
			})
			.catch((err) => {
				dispatch({
					type: NETWORK_ERROR_ADMINCREATECURRENCYMAPPING,
					payload: err
				});
			});
	};
function adminCreateCurrencyMappingsuccess(data) {
	return {
		type: ADMINCREATECURRENCYMAPPING_SUCCESS,
		payload: data
	};
}
function adminCreateCurrencyMappingFailed(data) {
	return {
		type: ADMINCREATECURRENCYMAPPING_FAILED,
		payload: data
	};
}

export { resetAdminCreateCurrencyMapping, adminCreateCurrencyMapping };
